/**
 * Status Message Helper
 * Centralized status message rendering with proper class management
 */

/* global document */

/**
 * Set status message with severity styling
 * @param opts - Message options
 */
export function setStatusMessage(opts: {
  element: HTMLElement;
  text: string;
  kind: "info" | "success" | "error";
}): void {
  const { element, text, kind } = opts;

  // Remove all severity classes
  element.classList.remove("status--error", "status--success", "status--info");
  
  // Remove inline color style if present
  if (element.style.color) {
    element.style.color = "";
  }

  // Add current severity class
  element.classList.add("status--" + kind);

  // Set text content
  element.textContent = text;
}

/**
 * Clear status message
 * @param element - Status element to clear
 */
export function clearStatusMessage(element: HTMLElement): void {
  // Remove all severity classes
  element.classList.remove("status--error", "status--success", "status--info");
  
  // Remove inline color style if present
  if (element.style.color) {
    element.style.color = "";
  }

  // Clear text
  element.textContent = "";
}
